import { render, staticRenderFns } from "./FerryCreate.vue?vue&type=template&id=7d162d5e"
import script from "@/controllers/custom/ferry/ferry-create.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/ferry/ferry-create.js?vue&type=script&lang=js&external"
import style0 from "./FerryCreate.vue?vue&type=style&index=0&id=7d162d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports